import { Component, OnInit } from '@angular/core';
import { ParametrosService } from 'src/app/services/parametros.service';
import { Ciiu } from '../../../comun/models/ciiu';
import { NeoCiiuExcluidoService } from '../../Service/neoCiiuExcluido.service';
import { NeoCiiuExcluido } from '../../Model/neoCiiuExcluido';
import { Router } from '@angular/router';
import { AlertService } from '../../../services/alert.service';
import { UserService } from '../../../services/user.service';
import { UntypedFormBuilder, FormControl, UntypedFormGroup } from '@angular/forms';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
declare var $: any;

@Component({
    selector: 'app-parametrizacion-actividades-economicas',
    templateUrl: './parametrizacion-actividades-economicas.component.html',
    styleUrls: ['./parametrizacion-actividades-economicas.component.scss'],
    providers: [NeoCiiuExcluidoService, ParametrosService],
    standalone: false
})
export class ParametrizacionActividadesEconomicasComponent implements OnInit {
  public ciius: Ciiu[] = [];
  public ciiusSeleccionados: Number[] = [];
  public neoCiiusExcluidos: NeoCiiuExcluido;
  ciiusMostrar: any[] = [];
  load: boolean = false;
  public user;
  pageActual:Number=1;
  public ciuuForm: UntypedFormGroup;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private _userIntermediarioService: UserService,
    private _parametrosService: ParametrosService,
    private _neoCiiuExcluidoService: NeoCiiuExcluidoService,
    public router: Router,
    private alertService: AlertService,
    private _sweetAlert:SweetAlertService
  ) {
    this.ciuuForm = this.formBuilder.group({
      ciiu: ['']
    });
    this.user = this._userIntermediarioService.getUser();
    this.neoCiiusExcluidos = new NeoCiiuExcluido(
      this.user.idCliente,
      null,
      this.user.idUsuario
    );
  }

  ngOnInit(): void {
    this._parametrosService.getActividades().subscribe(
      (response) => {
        return new Promise((resolve, reject) => {
          this.ciius = response['data'];
        });
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,'No fue posible cargar los ciius');
      },
      () => {
        setTimeout(() => {
          $('#select_ciiu').selectpicker('refresh');
        });
      }
    );
    this.cargarCiiusExcluidos();
  }

  cargarCiiusExcluidos(){
    this._neoCiiuExcluidoService
      .getCiiusExcluidosIF(this.user.idCliente)
      .subscribe(
        (response) => {
          this.ciiusMostrar = response;
          this.cargarCiiuSelect();
        },
        (error) => {
          this._sweetAlert.errorModal("Error!",true,
            'no fue posible cargar los ciius excluidos por el intermediario'
          );
        }
      );
  }

  cargarCiiuSelect(){
    this.ciiusSeleccionados.length = 0;
    for (let i = 0; i < this.ciiusMostrar.length; i++) {
      this.ciiusSeleccionados[i] = Number(this.ciiusMostrar[i].codigoCiiu);
    }
    this.ciuuForm.get('ciiu').setValue(this.ciiusSeleccionados);
    $('#select_ciiu').selectpicker('refresh');
  }

  registrarCambios() {
    this.neoCiiusExcluidos.ciius = this.ciuuForm.get('ciiu').value;
    this._neoCiiuExcluidoService
      .saveCiiusExlcuidos(this.neoCiiusExcluidos)
      .subscribe(
        (response) => {
          this._sweetAlert.successModal('Cambios Guardados');
          this.cargarCiiusExcluidos();
        },
        (error) => {
          this._sweetAlert.errorModal("Error!",true,'Error al guardar los cambios');
        }
      );
  }

  cancelar() {
    this.router.navigate(['/intermediario/home']);
  }
}
